<app-form-field-wrapper [label]="label" [name]="name" [colSize]="colSize">
  <p-dropdown
    id="defaultColorSet"
    [filter]="true"
    [showClear]="true"
    [(ngModel)]="selection"
    (ngModelChange)="onChange($event)"
    (onChange)="onDropdownChange($event.value)"
    [filterFields]="['name']"
    [options]="colorsets"
    [placeholder]="placeholder"
    optionLabel="name"
    optionValue="_id"
    panelStyleClass="colorset-dropdown-panel">
    <ng-template pTemplate="header">
      @if (enableNewOption) {
        <div class="p-2 border-bottom-1 surface-border">
          <p-button
            styleClass="w-auto"
            [text]="true"
            [rounded]="true"
            (onClick)="openColorsetForm()"
            icon="fas fa-plus"
            label="hinzufügen"></p-button>
        </div>
      }
    </ng-template>
    <ng-template pTemplate="selectedItem" let-selectedOption>
      @if (selectedOption) {
        <div class="colorset-row">
          <app-colors [colorset]="selectedOption" variant="strip" />
          <span class="colorset-name">{{ selectedOption.name }}</span>
        </div>
      }
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="colorset-row">
        <app-colors [colorset]="item" variant="strip" />
        <span class="colorset-name">{{ item.name }}</span>
        <span class="colorset-count">{{ item.colors.length }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</app-form-field-wrapper>
